/* Copyright (c) 2022 Xperi. All Rights Reserved. */

export const APP_START = 'APP_START';
export const OVERRIDE_PLAYBACK_PARAMS = 'OVERRIDE_PLAYBACK_PARAMS';
export const TURN_OFF_INITIAL_WELCOME = 'TURN_OFF_INITIAL_WELCOME';
export const TURN_ON_INITIAL_WELCOME = 'TURN_ON_INITIAL_WELCOME';
export const SET_SLS_GLOBAL_ENDPOINTS = 'SET_SLS_GLOBAL_ENDPOINTS';
export const IS_APPLICATION_READY = 'IS_APPLICATION_READY';
export const SET_PARTNER_BRANDING_IMAGE_URL = 'SET_PARTNER_BRANDING_IMAGE_URL';
export const UPDATE_COMMON_INACTIVITY_TIMESTAMP = 'UPDATE_COMMON_INACTIVITY_TIMESTAMP';
